import React from 'react';

import {
  IoMdCheckbox as Checked,
  IoMdSquareOutline as NotChecked
} from 'react-icons/io';

const Option = ({ value, onSelect }) => {

  const [selected, select] = React.useState(value)

  const OptionIcon = (!selected) ? NotChecked : Checked;

  const on_change_filter = () => {

    if (typeof (onSelect) === 'function') onSelect('out_of_stock',!selected);

    return select(!selected);

  }

  return (
    <div className="option noselect" onClick={on_change_filter}>

      <OptionIcon className='option-icon' />

      <span className='option-label'>Show Out Of Stock'</span>

    </div>
  );

}


export default ({ value, onSelect }) => {
  return (
    <div className='filter-group availability'>

      <div className="Heading">Availability</div>

      <Option value={value} onSelect={onSelect} />

    </div>
  )
}
